module.exports = __webpack_public_path__ + "media/src/images/arrow_right_on-ee448ec7bceef878dabb5c3ce44326ba.png";